import React from "react";
import SalesDocumentHeader from "../../components/SalesDocument/SalesDocumentHeader";
import { useTranslation } from "react-i18next";
const OrderEditPage: React.FC<{ params?: { [key: string]: any } }> = ({ params }) => {
    const { orderNo = "" } = params || {};
    const { t } = useTranslation();
    return (
        <SalesDocumentHeader
            key={orderNo}
            documentNo={orderNo}
            documentType={1}
            readUrl={`/orderApi/GetOrder/?documentNo=${orderNo}`}
            updateUrl="/orderApi/UpdateOrder"
            deleteUrl="taco"
            history={false}
            title={t("common.order")}
        />
    );
};

export default OrderEditPage;
